import { render, staticRenderFns } from "./ReligionUpdate.vue?vue&type=template&id=403313a2&"
import script from "./ReligionUpdate.vue?vue&type=script&lang=js&"
export * from "./ReligionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports